import store from '@/store';

// 房间火花标识不同等级
export const ROOM_SPARK_LEVEL = {
  NONE: -1, // 无火花
  FREEZE: 0, // 冷冻态
  SMALL: 1, // 2-30
  MEDIUM: 2, // 31-50
  LARGE: 3, // 51
};
// 用户火花标识不同等级
export const USER_SPARK_LEVEL = {
  NONE: 0, // 无火花
  SHORT: 1, // 连续7天
  LONG: 2, // 连续30天+
};

export const DEFAULT_LEVEL_CONFIG = {
  1: 7,
  2: 30,
};

const getSparkLevelConfig = () => {
  return (
    store.getters.global_config.spark_user_level_config?.level ??
    DEFAULT_LEVEL_CONFIG
  );
};
// 房间火花最小累计天数
export const ROOM_SPARK_MIN_CUMULATIVE_DAYS = 3;

// 用户火花最小连续天数
export const USER_SPARK_MIN_CONTINUOUS_DAYS = 7;

// 用户火花默认等级配置
const DEFAULT_USER_SPARK_LEVEL_CONFIG = [7, 30];

// 获取房间火花等级
export function getSparkRoomLevel(
  continues_days,
  cumulative_days,
  active_members
) {
  const sparkLevelConfig = store.getters.global_config.spark_room_level_config;
  if (!sparkLevelConfig) return ROOM_SPARK_LEVEL.NONE;
  const { show_fire_flag_day, level } = sparkLevelConfig;
  let status;
  if (cumulative_days < show_fire_flag_day) {
    status = ROOM_SPARK_LEVEL.NONE;
  } else if (continues_days < show_fire_flag_day) {
    status = ROOM_SPARK_LEVEL.FREEZE;
  } else {
    if (active_members >= level[ROOM_SPARK_LEVEL.LARGE]) {
      return ROOM_SPARK_LEVEL.LARGE;
    } else if (active_members >= level[ROOM_SPARK_LEVEL.MEDIUM]) {
      return ROOM_SPARK_LEVEL.MEDIUM;
    } else {
      return ROOM_SPARK_LEVEL.SMALL;
    }
  }
  return status;
}

// 获取房间的火花配置
export function getSparkRoomConfig(level) {
  if (!store.getters.global_config.spark_room_level_config || level === -1)
    return {};
  return store.getters.global_config.spark_room_config[level];
}

// 获取用户火花的等级
export function getSparkUserLevel(continues_days) {
  const sparkLevelConfig = store.getters.global_config.spark_user_level_config;
  if (!sparkLevelConfig) {
    return USER_SPARK_LEVEL.NONE;
  }
  const { level } = sparkLevelConfig;
  if (continues_days < level[USER_SPARK_LEVEL.SHORT]) {
    return USER_SPARK_LEVEL.NONE;
  } else if (continues_days < level[USER_SPARK_LEVEL.LONG]) {
    return USER_SPARK_LEVEL.SHORT;
  } else {
    return USER_SPARK_LEVEL.LONG;
  }
}

// 获取用户火花的配置
export function getSparkUserConfig(level) {
  if (level === USER_SPARK_LEVEL.NONE) {
    return {};
  }
  return store.getters.global_config.spark_user_config[level];
}

// 获取展示房间火花的最小天数
export function getShowSparkRoomMinDay() {
  return (
    store.getters.global_config.spark_room_level_config?.show_fire_flag_day ||
    ROOM_SPARK_MIN_CUMULATIVE_DAYS
  );
}

// 获取展示用户火花的最小天数
export function getShowSparkUserMinDay() {
  const levelConfig = getSparkLevelConfig();
  return levelConfig[USER_SPARK_LEVEL.SHORT] || USER_SPARK_MIN_CONTINUOUS_DAYS;
}

// 获取用户火花等级天数的临界值
export function getSparkUserLevelValues() {
  return Object.values(getSparkLevelConfig());
}

// 获取用户火花的tooltip提示
export function getSparkUserTooltip(level) {
  const levelConfig = getSparkLevelConfig();
  return `在房间中连续发送消息超过${levelConfig[level]}天`;
}
